module.exports = __webpack_public_path__ + "img/charging.b6b79802.svg";